import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import * as OptionController from '../../../controllers/OptionsController';
import { GlobalState } from '../../../states/global-state';
import type {
  CustomerAnswerSelectNoFloatOptionType,
  CustomerAnswerSelectNoFloatControl,
} from 'src/types/form-config';
import { signal, useSignalEffect } from '@preact/signals';
import { isSelectedCustomerAnswer } from '../../../routes/kyc/utils';

/**
 * dont use this in many options;
 * because it holds signal in every option;
 * this is commonly use for kyc - riskProfile & fatca only;
 */
const CustomSelectNoFloat = (props: CustomerAnswerSelectNoFloatControl) => {
  const controls = useRef(props);
  const [options, setOptions] = useState([]);

  const [selected, setSelected] = useState('');

  const states = useRef({});

  useSignalEffect(() => {
    // setOptions(props.options);
    const config = controls.current as CustomerAnswerSelectNoFloatControl;

    const selectedOptions = config.value;

    setOptions(config.options);

    setTimeout(() => {
      config.options.forEach(option => {
        const { selected } = isSelectedCustomerAnswer(
          option.value,
          selectedOptions
        );

        selected && setSelected(option.value);
      });
    }, 1000);
  });

  return (
    <div class="mb-4 form-group">
      <label for={props.name} class="mb-2">
        {props.label}
      </label>
      <select
        class="form-select input"
        id={props.name}
        value={selected}
        name={props.name}
        data-validator={props.validator || ''}
      >
        {options.map(item => {
          if (props.value == item.value) {
            return (
              <option selected value={item.value} key={item.key}>
                {item.display}
              </option>
            );
          }
          return (
            <option value={item.value} key={item.key}>
              {item.display}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default CustomSelectNoFloat;
